import * as Html from "../../util/Html.ts";
import * as focusme from "./focusme.ts";
import * as required from "./required.ts";

export {initDom}
Html.registerWidget('widget/form/focusme-required',{initDom:initDom})

function initDom(o: HTMLElement){
  focusme.initDom(o);
  required.initDom(o); // required.ts doit encore être migré
}